<template>
    <div id="Settings" class="row">
      <div class="mt-3 col-12">
        <div class="title row">
            <h4 class="text-center">SETTINGS</h4>
        </div>
        <div class="row">
            <div class="col-12">
                <span>Select Salesforce API URL</span>
            </div>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" name="environment" id="input-environment-live" value="live" :checked="environment == 'live'">
          <label class="form-check-label" for="input-environment-live">
            Live
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" name="environment" id="input-environment-testing" value="testing" :checked="environment == 'testing'">
          <label class="form-check-label" for="input-environment-testing">
            Testing
          </label>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'Settings',
    data() {
      return {
        environment : 'live',
      }
    }
  }
</script>
